import React from 'react';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';
import styles from './styles.scss';
import Utils from '../../../../utils/comments-utils';
import ManageCommentReply from '../manage-comments-comment-reply/ManageCommentsCommentReply';

/* CommentCard displays a single comment card */
const ManageCommentCard = function ManageCommentCard(props) {
    const {
        author, messagetext, created, pageUrl, targetname, reply, baseurl, messageKey, targetKey,
    } = props;

    const titleContent = author ? `${author}` : 'Anonymous';
    const createdContent = Utils.CalculateTimeDiff(created, true);

    return (
        <div className={styles.managecommentcard}>
            <div className="columns mb-0">
                <div className="column has-text-black">
                    <span>
                        {titleContent}
                    </span>
                    <span className="ml-1">
                        donated to
                    </span>
                    <span className="ml-1 has-text-weight-bold">
                        <a href={pageUrl} className={styles['blue-text']}>
                            {targetname}
                        </a>
                    </span>
                </div>
                <div data-testid="created-content-div" className={`column is-narrow ${styles['blue-text']}`}>
                    {createdContent}
                </div>
            </div>
            <div className={styles['long-comment']}>
                <ShowMoreText
                    /* Default options */
                    lines={3}
                    more="Show more"
                    less="Show less"
                    className="content-css"
                    expanded={false}
                    width={345}
                    truncatedEndingComponent="... "
                >
                    {messagetext}
                </ShowMoreText>
                <ManageCommentReply
                    reply={reply}
                    baseurl={baseurl}
                    parentMessageKey={messageKey}
                    targetKey={targetKey}
                    author={targetname} // ToDo: replace loggedin user
                />
            </div>
        </div>
    );
};

ManageCommentCard.propTypes = {
    author: PropTypes.string.isRequired,
    messagetext: PropTypes.string.isRequired,
    created: PropTypes.string.isRequired,
    pageUrl: PropTypes.string,
    targetname: PropTypes.string,
    reply: PropTypes.shape({
        MessageText: PropTypes.string.isRequired,
        Author: PropTypes.string.isRequired,
        TargetKey: PropTypes.string.isRequired,
    }),
    targetKey: PropTypes.string.isRequired,
    messageKey: PropTypes.string.isRequired,
    baseurl: PropTypes.string,
};

ManageCommentCard.defaultProps = {
    pageUrl: '',
    targetname: '',
    reply: null,
    baseurl: window.location.href,

};

export default ManageCommentCard;
